import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ConfigurationService } from '@sondermind/configuration';
import { HttpService } from '@sondermind/http';

import { W9TinType } from '../models/w9-tin-type';

export interface IW9Interview {
  id: string;
  providerId: string;
  status: string;
  taxClassification: string | null;
  llcElection: string | null;
  hasDba: boolean | null;
  businessName: string | null;
  mailingAddress: string | null;
  w9Line1: string | null;
  w9Line2: string | null;
  w9Line3a: string | null;
  tinType: W9TinType | null;
  tinLast4: string | null;
  createdAt: string | null;
  updatedAt: string | null;
}

/** Typed signature ceremony shown on the rendered W-9. */
export interface IW9Certification {
  /** Typed full legal name certifying the TIN. */
  signature: string;
  /** Signature date as stamped on the PDF overlay (MM/DD/YYYY). */
  date: string;
}

/** Body sent to POST /v1/w9/interviews/:id/confirm. */
export interface IW9ConfirmPayload {
  tin: string;
  tinType: W9TinType;
  /** Signature + date, nested per the service-engagement confirm contract. */
  certification: IW9Certification;
}

@Injectable({ providedIn: 'root' })
export class W9InterviewHttpService {
  constructor(
    private configurationService: ConfigurationService,
    private http: HttpService
  ) {}

  getLatestInterview(): Observable<IW9Interview | null> {
    const url = `${this.configurationService.env.engagementApiBase}/v1/w9/interviews?isLatest=true`;
    return this.http
      .get<IW9Interview[]>(url)
      .pipe(
        this.http.handleHttpError(),
        map((interviews) => (interviews.length > 0 ? interviews[0] : null))
      );
  }

  confirmInterview(id: string, payload: IW9ConfirmPayload): Observable<unknown> {
    const url = `${this.configurationService.env.engagementApiBase}/v1/w9/interviews/${id}/confirm`;
    return this.http
      .post<unknown>(url, payload)
      .pipe(this.http.handleHttpError({ null404: false }));
  }
}
